import { Navigate } from "react-router-dom"
import Root from "src/components/root/assistant/Root"
import ErrorPage from "src/pages/error/error-page"
import Dashboard from "src/pages/assistant/dashboard/Dashboard"
import Patients from "src/pages/assistant/patients/Patients"
import Settings from "src/pages/assistant/settings/Settings"
import Profile1 from "src/pages/assistant/patients/profile/Profile1"

const refresh_token = localStorage.getItem("refresh_token")
const access_token = localStorage.getItem("access_token")

const isSignIn = refresh_token && access_token

const assistantRoute = {
    path: "/assistant",
    element: isSignIn ? <Root /> : <Navigate to='/auth/login' />,
    errorElement: <ErrorPage />,
    children:[
      {
        path:'/assistant/dashboard',
        element:<Dashboard />
      },
      {
        path:'/assistant/patients',
        element:<Patients />
      },
      {
        path:'/assistant/patients/:id',
        element:<Profile1 />
      },

      {
        path:'/assistant/settings',
        element:<Settings />
      },
        
    ]

  }

  export default assistantRoute